import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Validation from '../Validation/Validation';
import MainCheckbox from '../MUI/MainCheckbox/MainCheckbox';
import TitleTypography from '../MUI/TitleTypography';

import useStyles from './makeStyles';

const AutomaticRecurringInfoBlock = ({ isDisabled, checked, errors, handleCheckboxChange }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <TitleTypography>
        {t('automaticRecurringPayment.agreementTitle')}
      </TitleTypography>
      <Validation name="attachCardAgreement" errors={errors}>
        <div className={classes.desktopSummaryCheckbox}>
          <label className={cn({ [classes.agreementLabelDisabled]: isDisabled })} htmlFor="attachCardAgreement">
            <MainCheckbox
              checked={checked}
              onChange={handleCheckboxChange}
              color="primary"
              style={{ marginRight: '0.5rem', marginTop: 4 }}
              disabled={isDisabled}
            />
          </label>
          <div className={cn(classes.agreementText, {
            [classes.agreementLabelDisabled]: isDisabled,
          })}
          >
            <p dangerouslySetInnerHTML={{
              __html: t('automaticRecurringPayment.agreementText'),
            }}
            />
          </div>
        </div>
      </Validation>
    </div>
  );
};

AutomaticRecurringInfoBlock.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  errors: PropTypes.shape({}).isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
};

export default AutomaticRecurringInfoBlock;
